/**
 * When a viewer connects to a room screen's cloud browser. Hyperbeam bills
 * every connected viewer per minute, so only people near the screen connect:
 * connect within `connect` metres; once connected, disconnect only after
 * staying beyond `disconnect` metres for `graceMs` (hysteresis, so walking
 * around the edge doesn't flap). Big screens get a proportionally larger
 * range so a cinema wall still works from its back rows.
 */
export interface RangeState { inRange: boolean; farSince: number | null }
export interface Range { connect: number; disconnect: number; graceMs: number }

export const CONNECT_M = 15;
export const DISCONNECT_M = 20;
export const DISCONNECT_GRACE_MS = 20_000;

export function screenRange(screenWidth: number): Range {
  const connect = Math.max(CONNECT_M, screenWidth * 1.25);
  return { connect, disconnect: connect + (DISCONNECT_M - CONNECT_M), graceMs: DISCONNECT_GRACE_MS };
}

export function screenRangeStep(s: RangeState, distance: number, now: number, r: Range): RangeState {
  if (!Number.isFinite(distance)) return s;
  if (!s.inRange) return distance <= r.connect ? { inRange: true, farSince: null } : s;
  if (distance <= r.disconnect) return s.farSince === null ? s : { inRange: true, farSince: null };
  if (s.farSince === null) return { inRange: true, farSince: now };
  return now - s.farSince >= r.graceMs ? { inRange: false, farSince: null } : s;
}
